module.exports = __webpack_public_path__ + "img/section-3-content_2_b_img.7d4cb7a7.png";